// extracted by mini-css-extract-plugin
export var bounce = "_m2-1";
export var generatingText = "_m2-6";
export var lightning = "_m2-4";
export var popup = "_m2-5";
export var progressBar = "_m2-7";
export var progressFill = "_m2-8";
export var progressShimmer = "_m2-9";
export var progressText = "_m2-a";
export var shimmer = "_m2-3";
export var uploadIcon = "_m2-0";
export var uploadingText = "_m2-2";